import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';

@Component({
  selector: 'app-sso-button',
  templateUrl: './sso-sign-in-header.component.html',
  styleUrls: ['./sso-sign-in-header.component.scss'],
  standalone: true,
})
export class SsoSignInHeaderComponent {
  constructor(private router: Router) {}

  handleSignInWithRedirect() {
    window.location.href = cognitoRedirectUrl;
  }
}
